var map = {
	"./abacha.webp": 1518,
	"./afang leaf.webp": 4430,
	"./banga seed.webp": 1254,
	"./beans.webp": 4377,
	"./bitter kola.webp": 8110,
	"./chin chin.webp": 3756,
	"./cornflakes.webp": 2912,
	"./crayfish.webp": 174,
	"./dried fish.webp": 3679,
	"./egusi.webp": 1842,
	"./garden egg.webp": 9648,
	"./golden morn.webp": 2054,
	"./groundnut.webp": 2415,
	"./hair conditioner.webp": 2139,
	"./hair relaxer.webp": 5557,
	"./hair shampoo.webp": 133,
	"./kilishi.webp": 2594,
	"./kola nut.webp": 6214,
	"./maggi.webp": 241,
	"./mango.webp": 8275,
	"./ogbono.webp": 8406,
	"./okra.webp": 8434,
	"./palm oil.webp": 9930,
	"./pawpaw.webp": 4709,
	"./plantain chips.webp": 3362,
	"./plantain.webp": 4099,
	"./red garri.webp": 7295,
	"./sharwarma bread.webp": 6686,
	"./soap.webp": 2862,
	"./stock fish.webp": 2339,
	"./ugu.webp": 407,
	"./watermelon.webp": 6368,
	"./white garri.webp": 2765,
	"./yam.webp": 8111
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5674;